module.exports = __webpack_public_path__ + "static/media/WorkSans_Regular.271ec2ac.woff2";